class Dom {
    /**
     * Check to see if the dom element is hidden. Hidden means the element does not take any space.
     * @param el the dom element
     * @returns {boolean}
     */
    isHidden(el) {
        return (el.getClientRects().length===0);
    }

    /**
     * check to see if the dom element is visible;
     *
     * @param el the dom element
     * @returns {boolean}
     */
    isVisible(el) {
        return (window.getComputedStyle(el).visibility!=='hidden') && !this.isHidden(el);
    }

    scaleFont(fontSize, scale) {
        const matches = fontSize.match(/([\d.]+)([a-zA-Z]+)/);
        let scaledFontSize = fontSize;
        if (matches) {
            const numericPart = matches[1]; // Numeric part
            const unitPart = matches[2];    // Unit part
            scaledFontSize = numericPart * scale + unitPart;
        }
        return scaledFontSize;
    }

    fontSize(element) {
        const htmlElement = (element instanceof Element) ? element : document.documentElement; // or you can use document.body;
        const fontSize = window.getComputedStyle(htmlElement).fontSize;
        const matches = fontSize.match(/([\d.]+)([a-zA-Z]+)/);
        return matches ? Number.parseFloat(matches[1]) : 12;
    }
}

const dom = new Dom();

export default dom;